import { Navigate, Route, Routes } from 'react-router-dom';

import { ROUTES } from '../core/constants/routes';
import { AuthRoute, ProtectedRoute } from '../global/contexts/auth/guards';
import DevicePage from '../pages/admin/device';
import HomePage from '../pages/admin/home';
import ProjectsPage from '../pages/admin/projects';
import ReviewsPage from '../pages/admin/reviews';
import TeamsPage from '../pages/admin/teams';
import WorkPage from '../pages/admin/work';
import LoginPage from '../pages/login';
import ShellPage from '../pages/shell';
import UnauthorizedPage from '../pages/unauthorized';

export default function AppRouter() {
    return (
        <Routes>
            <Route path={ROUTES.LOGIN} element={<LoginPage />} />
            <Route path={ROUTES.UNAUTHORIZED} element={<UnauthorizedPage />} />
            <Route element={<AuthRoute><ShellPage /></AuthRoute>}>
                <Route path={ROUTES.HOME} element={<ProtectedRoute any={['tasks:read', 'events:read']}><HomePage /></ProtectedRoute>} />
                <Route path="/admin/projects/:projectId?" element={<ProtectedRoute domain="projects:read"><ProjectsPage /></ProtectedRoute>} />
                <Route path="/admin/work/:taskId?" element={<ProtectedRoute domain="tasks:read"><WorkPage /></ProtectedRoute>} />
                <Route path="/admin/teams/:teamId?" element={<ProtectedRoute domain="teams:read"><TeamsPage /></ProtectedRoute>} />
                <Route path="/admin/reviews/:taskId?" element={<ProtectedRoute domain="tasks:read"><ReviewsPage /></ProtectedRoute>} />
                <Route path={ROUTES.DEVICE} element={<AuthRoute><DevicePage /></AuthRoute>} />
            </Route>
            <Route path="*" element={<Navigate to={ROUTES.HOME} replace />} />
        </Routes>
    );
}
